import ReportCardTemplate from "@/components/admin/ReportCardTemplate";

/**
 * Standalone preview for the 8.5x11 report card template.
 * Shown centered on a gray "print preview" background so the true US Letter
 * proportions are obvious. Use Cmd/Ctrl+P to print at exact 300 DPI.
 */
export default function ReportTemplatePreview() {
  return (
    <div
      className="min-h-screen w-full bg-[#4a4a4a] py-10"
      data-testid="report-template-preview"
    >
      <div className="mx-auto mb-6 max-w-[8.5in] px-2 font-body text-sm text-white/80">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <span>
            Report Card Template &middot; <strong>8.5&Prime; &times; 11&Prime;</strong> US Letter &middot; 2550&times;3300 @ 300 DPI
          </span>
          <span className="text-white/60">Layout pass 1 — spacing to be fine-tuned</span>
        </div>
      </div>

      <div className="mx-auto" style={{ width: "8.5in" }}>
        <ReportCardTemplate />
      </div>
    </div>
  );
}
